import { render, staticRenderFns } from "./DeleteCategories.vue?vue&type=template&id=34dc434e&scoped=true"
import script from "./DeleteCategories.vue?vue&type=script&lang=js"
export * from "./DeleteCategories.vue?vue&type=script&lang=js"
import style0 from "./DeleteCategories.vue?vue&type=style&index=0&id=34dc434e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc434e",
  null
  
)

export default component.exports